import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Start",
    component() {
      return import("@/components/start");
    }
  },
  {
    path: "/p/:id/record.html",
    name: "Recorder",
    component() {
      return import("@/components/client/index.vue");
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
